export const environment = {
  production: false,
  recaptcha: {
    siteKey: '6Lff2jonAAAAALXZ6pNxOOyF5jCYjnAckrn7670m'
  }
};
